const elements = [
  {
    num: 1,
    title: 'Ambitiegesprek',
    content: `Hoe ziet jouw tech dream eruit? In dit gesprek deel jij met ons hoe jij een derde van je leven wilt doorbrengen en onder welke voorwaarden. Dit gesprek kunnen we persoonlijk, telefonisch of via Skype doen en is ons startpunt voor de zoektocht naar jouw ideale baan.`,
    icon: 'comments-duotone'
  },
  {
    num: 2,
    title: 'Jouw keuzemogelijkheden',
    content: `Waar wil je werken? Synsel heeft een groot netwerk van +2500 innovatieve werkgevers. Afhankelijk van de wensen die jij hebt geuit in het ambitiegesprek, kiezen we met elkaar bij welke bedrijven jouw beste carrièrekansen liggen.`,
    icon: 'comments-duotone'
  },
  {
    num: 3,
    title: 'Jouw cv-upgrade',
    content: `Een sterk cv opent deuren naar de beste werkgevers. We helpen je om jouw cv te upgraden zodat jouw vakmanschap en persoonlijkheid echt tot zijn recht komen. Zo kan geen enkele werkgever meer om jou heen.`,
    icon: 'comments-duotone'
  },
  {
    num: 4,
    title: 'Onze sollicitatietips',
    content: `Solliciteren is jouw werk niet. Gelukkig is dat wel onze baan. We delen tips waarmee je tijdens een sollicitatiegesprek krachtig reageert op vragen en je de baas blijft over eventuele zenuwen. En natuurlijk kennen we het bedrijf waar je op gesprek gaat, dus ontvang jij ook ‘inside information’.`,
    icon: 'comments-duotone'
  },
  {
    num: 5,
    title: 'Altijd meerdere werkgevers',
    content: `1 keuze is geen keuze. Daarom adviseren én ondersteunen we je altijd om bij meerdere werkgevers op gesprek te gaan. Alleen zo krijg je een goed beeld van het bedrijf en de baan die het beste bij jou en jouw ambities past.`,
    icon: 'comments-duotone'
  },
  {
    num: 6,
    title: 'De beste arbeidsvoorwaarden',
    content: `De beste baan is er 1 die op alle fronten aansluit bij wie jij bent en wat je wilt. En dus zetten we alles op alles zodat jij krijgt wat je verdient. Van een goed salaris tot prima secundaire arbeidsvoorwaarden. Van doorgroeimogelijkheden tot een reiskostenvergoeding.`,
    icon: 'comments'
  }
];

export default elements;
